import { arrayToMap } from '../util'

export const path = '/master/common';

export const handler = (data) => {
  const prefs = data.prefs;
  for (const pref of prefs) {
    pref.shortName = pref.name.replace(/[都府県]$/, "");
  }
  return {
    list: prefs,
    bySlug: arrayToMap(prefs, "slug"),
    byId: arrayToMap(prefs, "prefId"),
  };
}



// WEBPACK FOOTER //
// ./lib/masterData/schemas/prefAsync.js